import { apiGetList } from './ApiBaseActions';
export const API_GET_LIST_PROFFIT_SEARCH_SHARE_HEADER = 'API_GET_LIST_PROFFIT_SEARCH_SHARE_HEADER';
export const API_GET_LIST_PROFFIT_SEARCH_SHARE_HEADER_SUCCESS = 'API_GET_LIST_PROFFIT_SEARCH_SHARE_HEADER_SUCCESS';
/**
 * 共有履歴の取得（ヘッダー用）
 * @param data
 * @param meta
 * @returns {{payload: {params: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetListProffitSearchShareHeader = (data = {}, meta = {}) => apiGetList(API_GET_LIST_PROFFIT_SEARCH_SHARE_HEADER, '/proffit_search/slide/share', Object.assign({ sort: 'unread' }, data), meta);
